import React from "react";
import { Form } from "@redriver/cinnamon";
import { getTitles } from "./actions";

export const TitlesDropdown = (props) => (
  <Form.Dropdown {...props} lookupAction={getTitles} />
);

export default TitlesDropdown;
